module.exports = __webpack_public_path__ + "static/media/territorio-digital.daa6569a.png";